import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "cms-card-block"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "cms-module-title mg-t--15"
}, "关联主题", -1);

import ActionHeader from '@/views/common/ActionHeader/index.vue';
import FormTable from '@/components/FormTable/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import Column from '@/components/CommonTable/Column.vue';
const __default__ = {
  name: "PlanAction"
};
export default /*#__PURE__*/_defineComponent({ ...__default__,

  setup(__props) {
    const headerConfig = reactive({
      title: "新增方案",
      btnList: [{
        label: '返回',
        func: () => {}
      }]
    });
    const buttonsList = ref([{
      label: '选择主题',
      func: () => {}
    }]);
    const actionForm = reactive({
      formList: [[{
        label: '方案名称',
        prop: 'name',
        widgetType: 'input'
      }, {
        label: '描述',
        prop: 'description',
        widgetType: 'input'
      }]],
      formData: {
        name: '',
        description: ''
      }
    });
    const actionTable = reactive({
      data: [],
      isShowHeader: false,
      showPageBar: false,
      isCardBlock: false,
      columnList: [{
        label: '序号',
        prop: ''
      }, {
        label: '主题名称',
        prop: 'name'
      }, {
        label: '主题类型',
        prop: 'type'
      }, {
        label: '推荐位模板',
        prop: 'te'
      }, {
        label: '描述',
        prop: 'description'
      }, {
        label: '操作',
        widgetType: 'buttons',
        buttonsList: [{
          label: '删除',
          func: () => {}
        }]
      }]
    });
    return (_ctx, _cache) => {
      const _component_CommonTable = _resolveComponent("CommonTable");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(ActionHeader, {
        config: headerConfig
      }, null, 8, ["config"]), _createElementVNode("div", _hoisted_1, [_createVNode(FormTable, {
        col: ['20%', '30%', '20%', '30%'],
        "form-list": actionForm.formList,
        "form-data": actionForm.formData
      }, null, 8, ["form-list", "form-data"]), _hoisted_2, _createVNode(Buttons, {
        class: "mg-b--15",
        buttonsList: buttonsList.value
      }, null, 8, ["buttonsList"]), _createVNode(_component_CommonTable, {
        "table-config": actionTable
      }, {
        default: _withCtx(() => [_createVNode(Column, {
          "column-list": actionTable.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config"])])]);
    };
  }

});